<template>
  <div>
    <div class="page-head">
      <div><h2>推荐官管理</h2><p>集中查询推荐关系、关联订单和佣金结算记录。</p></div>
    </div>
    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="姓名/昵称/推荐码/手机号" clearable /></el-form-item>
        <el-form-item label="状态"><el-select v-model="filters.status" clearable placeholder="全部"><el-option label="启用" value="active"/><el-option label="停用" value="inactive"/></el-select></el-form-item>
        <el-form-item><el-button type="primary" @click="page=1;fetchList()">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>
      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page=$event;fetchList()" @size-change="pageSize=$event;page=1;fetchList()">
        <el-table-column prop="recommender_code" label="推荐官码" min-width="180" />
        <el-table-column prop="name" label="姓名" min-width="120" />
        <el-table-column prop="nickname" label="小程序昵称" min-width="130" />
        <el-table-column prop="phone" label="手机号" width="135" />
        <el-table-column prop="binding_total" label="绑定用户" width="100" />
        <el-table-column prop="order_total" label="关联订单" width="100" />
        <el-table-column label="成交金额" width="120"><template slot-scope="{row}">¥{{ money(row.paid_amount) }}</template></el-table-column>
        <el-table-column label="待结佣金" width="120"><template slot-scope="{row}">¥{{ money(row.pending_commission) }}</template></el-table-column>
        <el-table-column label="已结佣金" width="120"><template slot-scope="{row}">¥{{ money(row.settled_commission) }}</template></el-table-column>
        <el-table-column prop="status" label="状态" width="90"><template slot-scope="{row}"><status-tag :value="row.status"/></template></el-table-column>
        <el-table-column label="操作" width="90"><template slot-scope="{row}"><el-button type="text" @click="openDetail(row)">详情</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <el-dialog title="推荐官业务详情" :visible.sync="visible" width="86%" top="5vh">
      <div v-if="detail.recommender" class="summary-grid">
        <div><span>推荐官码</span><strong>{{ detail.recommender.recommender_code }}</strong></div>
        <div><span>绑定用户</span><strong>{{ summary.binding_total || 0 }}</strong></div>
        <div><span>推荐订单</span><strong>{{ summary.order_total || 0 }}</strong></div>
        <div><span>成交金额</span><strong>¥{{ money(summary.paid_amount) }}</strong></div>
        <div><span>待结佣金</span><strong>¥{{ money(summary.pending_commission) }}</strong></div>
        <div><span>已结佣金</span><strong>¥{{ money(summary.settled_commission) }}</strong></div>
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="绑定用户" name="users">
          <el-table :data="detail.items || []" border size="small" max-height="52vh">
            <el-table-column prop="nickname" label="昵称"/><el-table-column prop="phone" label="手机号（脱敏）"/><el-table-column prop="bind_source" label="绑定来源"/><el-table-column label="绑定时间"><template slot-scope="{row}">{{ row.bind_time | dateTime }}</template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="关联订单" name="orders">
          <el-table :data="detail.orders || []" border size="small" max-height="52vh">
            <el-table-column prop="order_no" label="订单号" min-width="190"/><el-table-column prop="name" label="订单名称"/><el-table-column prop="user_nickname" label="客户昵称"/><el-table-column label="合同/订单金额"><template slot-scope="{row}">¥{{ money(row.contract_amount || row.amount) }}</template></el-table-column><el-table-column label="已收金额"><template slot-scope="{row}">¥{{ money(row.received_amount) }}</template></el-table-column><el-table-column prop="payment_status" label="支付状态"/><el-table-column prop="status" label="订单状态"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="佣金流水" name="commissions">
          <el-table :data="detail.commissions || []" border size="small" max-height="52vh">
            <el-table-column prop="order_no" label="订单号" min-width="190"/><el-table-column label="计算基数" width="110"><template slot-scope="{row}">¥{{ money(row.commission_base_amount) }}</template></el-table-column><el-table-column label="返佣规则" width="130"><template slot-scope="{row}">{{ commissionRule(row) }}</template></el-table-column><el-table-column label="佣金" width="110"><template slot-scope="{row}">¥{{ money(row.amount) }}</template></el-table-column><el-table-column prop="status" label="状态" width="100"/><el-table-column prop="remark" label="说明" min-width="150"/>
            <el-table-column label="操作" width="140"><template slot-scope="{row}"><el-button v-if="row.status==='pending'" type="text" @click="settle(row)">结算</el-button><el-button v-if="row.status==='pending'" type="text" class="danger-text" @click="cancel(row)">取消</el-button></template></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import http from "../api/http";
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";

export default {
  name: "RecommendersManage",
  components: { PagedTable, StatusTag },
  data() { return { loading:false,rows:[],page:1,pageSize:20,total:0,filters:{keyword:"",status:""},visible:false,activeTab:"users",detail:{},activeRow:null }; },
  computed: { summary() { return this.detail.summary || {}; } },
  mounted() { this.fetchList(); },
  methods: {
    money(value) { return Number(value || 0).toFixed(2); },
    percent(value) { return `${(Number(value || 0) * 100).toFixed(2).replace(/\.00$/, "")}%`; },
    commissionRule(row) {
      let snapshot = row && row.rule_snapshot_json;
      if (typeof snapshot === "string") { try { snapshot = JSON.parse(snapshot); } catch (error) { snapshot = {}; } }
      if (snapshot && snapshot.commission_mode === "fixed") return `固定 ¥${this.money(snapshot.commission_fixed_amount)}`;
      return `比例 ${this.percent(row && row.commission_rate)}`;
    },
    async fetchList() { this.loading=true; try { const res=await http.get("/recommenders",{params:{...this.filters,page:this.page,pageSize:this.pageSize}}); const data=res.data||{};this.rows=data.items||[];this.total=Number(data.total||0); } finally { this.loading=false; } },
    reset() { this.filters={keyword:"",status:""};this.page=1;this.fetchList(); },
    async openDetail(row) { this.activeRow=row;this.activeTab="users";this.visible=true;await this.reloadDetail(); },
    async reloadDetail() { const res=await http.get(`/recommenders/${this.activeRow.id}`);this.detail=res.data||{}; },
    async settle(row) { await this.$confirm("确认将该笔佣金标记为已结算？","佣金结算",{type:"warning"});await http.post(`/referral-commissions/${row.id}/settle`,{});this.$message.success("佣金已结算");await Promise.all([this.reloadDetail(),this.fetchList()]); },
    async cancel(row) { try { const result=await this.$prompt("请输入取消原因","取消佣金",{inputValidator:value=>String(value||"").trim()?true:"必须填写原因"});await http.post(`/referral-commissions/${row.id}/cancel`,{reason:result.value});this.$message.success("佣金已取消");await Promise.all([this.reloadDetail(),this.fetchList()]); } catch(error) { if(error!=="cancel"&&error!=="close"&&error.message)this.$message.error(error.message); } }
  }
};
</script>

<style scoped>
.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.summary-grid > div {
  min-width: 0;
  padding: 14px;
  background: #f7f8fa;
  border-radius: 8px;
}

.summary-grid span,
.summary-grid strong {
  display: block;
}

.summary-grid span {
  color: #909399;
  font-size: 12px;
}

.summary-grid strong {
  margin-top: 8px;
  overflow-wrap: anywhere;
  font-size: 18px;
  line-height: 1.35;
}

.danger-text {
  color: #f56c6c;
}

@media (max-width: 700px) {
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
